import { PureComponent } from 'react';
// @ts-expect-error untyped module
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import { getIframeSrc } from 'quotes-modal-lib/utils/urls';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { MSG_TYPE_FLOW_START, MSG_TYPE_HIDE_MODAL, MSG_TYPE_MODAL_HIDDEN, MSG_TYPE_ADD_ALERT } from 'quotes-modal-lib/constants/Messages';
import { isComingFromCommerceHubUserGuide } from 'growth-payments-core/urls/utils';
import { jsx as _jsx } from "react/jsx-runtime";
class QuotesIFrameModal extends PureComponent {
  constructor(props) {
    super(props);
    this.handleOnReady = hostContext => {
      this.setState({
        hostContext
      }, () => {
        if (this.state.openedBeforeSync) {
          const {
            dealId,
            templateId,
            quoteId,
            flowType,
            embedSource
          } = this.props;
          this.sendFlowStartMessageToIFrame({
            dealId,
            templateId,
            quoteId,
            flowType,
            embedSource
          });
          this.setState({
            openedBeforeSync: false
          });
        }
      });
    };
    this.registerFlowStartMessageAfterSync = () => this.setState({
      openedBeforeSync: true
    });
    this.sendFlowStartMessageToIFrame = ({
      dealId,
      templateId,
      quoteId,
      flowType,
      embedSource
    }) => {
      window.onpopstate = this.handleCloseModal;
      if (this.state.hostContext) {
        this.state.hostContext.sendMessage(MSG_TYPE_FLOW_START, {
          dealId,
          templateId,
          quoteId,
          flowType,
          embedSource
        });
      }
    };
    this.sendModalHiddenMessageToIframe = () => {
      if (this.state.hostContext) {
        this.state.hostContext.sendMessage(MSG_TYPE_MODAL_HIDDEN);
      }
    };
    this.handleError = error => {
      console.error(error);
      this.handleCloseModal();
      if (this.props.onError) {
        this.props.onError();
      }
    };
    this.handleMessage = message => {
      const {
        payload: {
          type,
          alertProps
        }
      } = message;
      if (type === MSG_TYPE_HIDE_MODAL) {
        this.handleCloseModal();
      }
      if (type === MSG_TYPE_ADD_ALERT) {
        // Trellis Migration: Can't be replaced with transitional FloatingAlertStore until issue is resolved
        // https://git.hubteam.com/HubSpot/foundations-components/issues/2980
        // https://hubspot.slack.com/archives/C1WG3L3J6/p1738001231512159
        FloatingAlertStore.addAlert(alertProps);
      }
    };
    this.handleCloseModal = () => {
      window.onpopstate = null;
      if (this.props.onClose) {
        this.props.onClose();
      }
    };
    this.state = {
      hostContext: null,
      openedBeforeSync: false
    };
  }
  componentDidUpdate(prevProps) {
    // when show is false and becomes true, time to make the prerendered modal visible
    if (!prevProps.show && this.props.show) {
      // if the modal is opened before sync with iframe, wait for sync before starting the flow
      if (!this.state.hostContext) {
        this.registerFlowStartMessageAfterSync();
      } else {
        this.sendFlowStartMessageToIFrame(this.props);
      }
    }
    if (prevProps.show && !this.props.show) {
      this.sendModalHiddenMessageToIframe();
    }
  }
  render() {
    const {
      show
    } = this.props;
    const {
      openedBeforeSync
    } = this.state;
    /*
      We want to avoid preloading the iframe modal when we're displaying an onboarding tour. There are two reasons for this:
      1. `ui-addon-iframeable` adds a custom z-index on preloaded frames that clashes with the onboarding task handholding banners.
      2. The iframe is preloaded with size 0x0, which causes the tour to break since the shepherds are not able to find and attach to
      their target elements.
       More context in this PR: https://git.hubteam.com/HubSpot/quotes-admin/pull/6478
    */
    const shouldPreload = !isComingFromCommerceHubUserGuide();
    return /*#__PURE__*/_jsx(UIModalIFrame, {
      appName: "quotes-admin",
      iframePassthruProps: {
        'data-test-id': `quotes-admin-iframe-${show ? 'open' : 'closed'}`,
        name: 'quotes-admin-iframe',
        id: 'quotes-admin-iframe'
      }
      // the wizard will not load at all if the sync times out, so using a massive timeout to be safe.
      ,
      initTimeout: 60000,
      preload: shouldPreload,
      show: show,
      use: "fullscreen",
      width: "100%",
      height: "100%",
      src: getIframeSrc(),
      showLoadingIndicator: openedBeforeSync,
      onInitError: this.handleError,
      onReady: this.handleOnReady,
      onReadyError: this.handleError,
      onMessage: this.handleMessage,
      onClose: this.handleCloseModal
    });
  }
}
export default QuotesIFrameModal;